import { diffChars } from 'diff/lib/diff/character';
import * as ottext from 'ot-text/lib/text';
import { IOTActionHandler } from './documentmanagers/ot';

export const stringChangeToOps = (oldValue: string, newValue: string): ottext.Op => {
  const fullOp = diffChars(oldValue, newValue).map((x): ottext.Component => {
    if (x.added) {
      return x.value;
    } else if (x.removed) {
      return { d: x.value.length };
    } else {
      return x.value.length;
    }
  });
  if (typeof fullOp[fullOp.length - 1] === 'number') {
    fullOp.pop(); // TODO: tests for this
  }
  return fullOp;
};

export interface IOTTextAction {
  op: ottext.Op;
}

export class OTTextActionHandler implements IOTActionHandler<string, IOTTextAction> {
  public apply(document: string, x: IOTTextAction): string {
    return ottext.apply(document, x.op);
  }

  public transform(x: IOTTextAction, y: IOTTextAction): [IOTTextAction, IOTTextAction] {
    return [
      { op: ottext.transform(x.op, y.op, 'left') },
      { op: ottext.transform(y.op, x.op, 'right') },
    ];
  }

  public compose(x: IOTTextAction, y: IOTTextAction): IOTTextAction {
    return {
      op: ottext.compose(x.op, y.op),
    };
  }
}
